/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { isIterable } from '../typecheck/index.js';

export const toEntries = <TKeys extends string | number | symbol, TValues>(
  mixed: Record<TKeys, TValues> | Iterable<[TKeys, TValues]>
): [TKeys, TValues][] => (isIterable(mixed) ? Array.from(mixed) : (Object.entries(mixed) as any));
